/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Clear';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import qs from 'qs';
import mbpLogger from 'mbp-logger';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import ElasticSearchSuggestions from './ElasticSearchSuggestions/ElasticSearchSuggestions';
import SearchResultDropDown from '../../Header/components/Search/searchResultDropDown';

import customBreakpoints from '../../../helpers/customBreakpoints';
import { operations, selectors } from '../../../../state/ducks/App';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager';

const styles = (theme) => ({
    searchForm: {
        position: 'relative',
        display: 'flex',
        height: '83px',
        width: '100%',
        '& .MuiButtonBase-root': {
            /* color: theme.palette.cms?.white || '#ffffff',
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary, */
            '&:focus': {
                outline: 0,
            },
            '&:hover': {
                backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
            },
        },
    },
    searchFormIe: {
        display: 'flex',
        width: '100%',
        height: '39px',
        position: 'relative',
    },
    searchFormLabel: {
        position: 'relative',
        [theme.breakpoints.down(1026)]: {
            width: '100%',
        },
    },
    ariaInvisible: {
        clip: 'rect(0 0 0 0)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        width: '1px',
    },
    searchBoxLabel: {
        marginRight: '10px',
        position: 'relative',
    },
    searchBoxLabelHeaderRaised: {
        marginRight: '0',
        position: 'relative',
    },
    searchIcon: {
        position: 'absolute',
        top: '3px',
        left: '3px',
        color: theme.palette.grey4,
    },
    searchIconRaised: {
        position: 'relative',
        color: theme.palette.white,
        fontSize: '22px',
    },
    searchInput: {
        border: `1px solid ${theme.palette.grey8}`,
        color: `${theme?.palette?.common?.black || '#000'}`,
        fontSize: '4.0625rem',
        fontFamily: theme?.typography?.secondaryFontFamily,
        textIndent: '10px',
        height: '37px',
        width: '100%',
        '&:focus': {
            outline: 0,
        },
        '&::placeholder': {
            color: theme.palette.black,
            fontSize: '14px',
            [theme.breakpoints.down('600')]: {
                fontSize: '10px',
            },
        },
    },
    wrappHomePage: {
        padding: '20px 10px 10px',
    },
    wrappDesktopHomePage: {
        width: '100%',
        display: 'flex',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            flexGrow: '1',
            margin: '0 3vw',
        },
    },
    searchLabel: {
        width: '100%',
        display: 'flex',
        color: `${theme?.palette?.common?.black || '#000'}`,
        fontStyle: 'italic',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            flexGrow: '1',
            margin: '0 3vw',
        },
        [theme.breakpoints.up(customBreakpoints.tabLandscape)]: {
            display: 'none',
        },
    },
    textDanger: {
        color: theme?.palette?.common?.red,
    },
    wrappHeaderRaised: {
        padding: '0 10px 10px',
    },
    searchInputMenu: {
        borderRadius: '4px',
        textIndent: '0px',
    },
    searchInputHome: {
        borderRadius: '0',
        textIndent: '34px',
        height: '30px',
        border: '0',
        borderBottom: `1px solid ${theme.palette.grey8}`,
        fontFamily: theme.typography.fontFamily,
    },
    searchInputDesktopHome: {
        borderRadius: '0',
        width: '100%',
        borderBottom: `1px solid ${theme?.palette?.common?.gray}`,
        color: `${theme?.palette?.common?.black}`,
        border: 0,
        height: 'auto',
        outline: '0px',
        fontSize: '4.0625rem',
        minWidth: '100%',
        fontFamily: `${theme?.typography?.secondaryFontFamily}`,
        '&::placeholder': {
            fontSize: '4.0625rem',
            color: `${theme?.palette?.common?.gray}`,
        },
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '100%',
        },
    },
    searchInputHeaderRaised: {
        borderRadius: '4px 0 0 4px',
        textIndent: '4px',
        fontSize: 'inherit',
        height: '40px',
        color: theme.palette.black,
        fontFamily: theme.typography.fontFamily,
    },
    searchButton: {
        color: theme.palette.white,
        textTransform: 'uppercase',
        fontSize: '13px',
        backgroundColor: theme.palette.primaryButton,
        '-webkit-font-smoothing': 'antialiased',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            outline: `1px solid  ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
            outlineColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    searchButtonMenu: {
        minWidth: '80px',
        padding: '5px 14px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: '700',
    },
    searchButtonHome: {
        minWidth: '100px',
        padding: '2px  14px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: '700',
        minHeight: '27px',

    },
    // Override the MFE MUI
    searchButtonDesktopHome: {
        textIndent: '-999px',
        overflow: 'hidden',
        width: '25px',
        padding: '0',
        margin: '0',
        border: '1px solid transparent',
        borderRadius: 'inherit',
        backgroundColor: 'transparent',
        backgroundImage: 'url(https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt1c0d432472fa55bb/63bfb385a0db4d3e821f00b4/searchImage.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        cursor: 'pointer',
        opacity: '0.7',
        right: '0',
        outline: 'none',
        [theme.breakpoints.down('sm')]: {
            top: '25px',
        },
    },
    searchButtonDesktopHomeIe: {
        minWidth: '13%',
        margin: '0 auto',
        padding: '9px  14px',
        textTransform: 'uppercase',
        fontSize: '12px',
        fontWeight: '700',
        minHeight: '27px',
        borderRadius: '0 3px 3px 0',
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        '&:hover': {
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        '&:focus': {
            outline: `1px solid  ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
            outlineColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    classSearchBoxDesktopLabel: {
        margin: '0',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        height: '83px',
    },
    searchButtonHeaderRaised: {
        minWidth: '40px',
        minHeight: '40px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: '0 2px 2px 0',
        backgroundColor: theme.palette.grey1,
    },
    hasValue: {
        fontSize: '4.0625rem',
        fontFamily: theme?.typography?.secondaryFontFamily,
    },
    progress: {
        margin: '4px',
        color: theme.palette.brown5,
    },
    modalContent: {
        position: 'absolute',
        width: '60%',
        backgroundColor: theme.palette.white,
        boxShadow: theme.shadows[5],
        padding: '10px',
        textAlign: 'center',
        borderRadius: '4px',
        '&:focus': {
            outline: `solid 1px ${theme.palette.cta1}`,
            boxShadow: `0 0 10px ${theme.palette.cta1}`,
        },
        '& .MuiButtonBase-root': {
            padding: '2px',
            position: 'absolute',
        },
    },
    descModal: {
        color: theme.palette.cta1,
        marginTop: '0px',
    },
    closeIconButton: {
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        padding: '2px',
    },
    closeIcon: {
        backgroundColor: theme.palette.cta1,
        borderRadius: '100%',
        color: theme.palette.white,
        fontSize: '24px',
        padding: '1px',
    },
    resetSearchIcon: {
        padding: '4px',
        minWidth: '60px',
        maxWidth: '60px',
        height: '60px !important',
        position: 'absolute',
        right: '10px',
        color: theme.palette.white,
        fontSize: '12px',
        background: theme.palette.grey3,
        borderRadius: '50%',
        top: '10px',
        '&.PLA': {
            top: '30px',
            minWidth: '28px',
            color: 'black',
            background: 'none',
            height: '28px !important',
        },
    },
    resetSearchIconHide: {
        display: 'none !important',
    },
    resetSearchIconShow: {
        display: 'block',
        cursor: 'pointer',
    },
    searchPlaceholderError: {
        '&::placeholder': {
            color: theme.palette.error?.main || '#ff0000',
        },
    },
    recentsHeader: {
        fontWeight: 'bold',
    },
    recentsItem: {
        cursor: 'pointer',
    },
    clearRecents: {
        cursor: 'pointer',
    },
    searchInputBox: {
        paddingRight: '2.5rem',
        flex: '1',
    },
    clearSearchIconBtn: {
        position: 'absolute',
        right: '0.5rem',
    },
});

const ENTER_KEY = 13; // carriage-return
const PROMPT = 'TYPE KEYWORD AND PRESS ENTER';
const PROMPTRAISED = 'TYPE KEYWORD AND PRESS ENTER';
const PROMPTHOME = 'TYPE KEYWORD AND PRESS ENTER';
const MODALMESSAGE = 'TYPE KEYWORD AND PRESS ENTER !';

// Props:
//    languageId    id for language (-1 for English)
//    brand         object representing brand currently displaying for user.  Fields used include:
//                      storeId, catalogId, code
export class Search extends Component {
    constructor(props) {
        super(props);

        const type = props.typeSearchBox;
        let searchPlaceholder = PROMPT;
        let currentPrompt = PROMPT;
        this.searchBrands = ['PLA', 'HD', 'SY', 'WLF'];
        if (props.searchInputTerm) {
            searchPlaceholder = props.searchInputTerm.replace('+', ' ');
        } else if (type === 'homepage') {
            searchPlaceholder = PROMPTHOME;
            currentPrompt = PROMPTHOME;
        }

        if (this.searchBrands.includes(props.brand.code)) {
            searchPlaceholder = PROMPTRAISED;
            currentPrompt = PROMPTRAISED;
        }

        this.state = {
            loading: false,
            searchPlaceholderValue: searchPlaceholder,
            searchValue: '',
            currentPrompt,
            showClearIcon: false,
            ieBrowser: false,
            showInputValue: false,
            showRecents: false,
            deviceType: props.ssrDeviceType,
        };

        this.searchRef = createRef();
        this.searchContainerRef = createRef();
        this.handleClickOutsideSearch = this.handleClickOutsideSearch.bind(this);
        this.esAutoCompleteEnabled = true;
    }

    componentDidMount() {
        const {
            clearSearchResult, focusOnShow, history,
        } = this.props;
        if (typeof document !== 'undefined') {
            const ieBrowser = /* @cc_on!@ */false || !!document.documentMode;
            this.setState({ ieBrowser });
            clearSearchResult({});
            if (focusOnShow && this.searchRef?.current) {
                this.searchRef.current.focus();
            }
            document.addEventListener('mousedown', this.handleClickOutsideSearch);
        }

        try {
            const location = history.location;
            const decodedString = decodeURI(location?.search).replace('?', '');
            const queryParams = qs.parse(decodedString);
            let searchParam = queryParams?.q;
            if (typeof queryParams.q === 'string') {
                searchParam = queryParams.q;
            }
            this.setState((prevState) => ({
                ...prevState,
                searchValue: searchParam,
            }), () => this.onKeyUp());
        } catch (errors) {
            mbpLogger.logError({
                message: 'Malformed URI',
                error: errors,
                module: 'SearchInput',
                function: 'SearchInput',
            });
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('mousedown', this.handleClickOutsideSearch);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { searchPlaceholderValue } = prevState;

        if (searchPlaceholderValue === MODALMESSAGE) {
            this.setState({ searchPlaceholderValue: PROMPT });
        }
    }

    onChange = (event) => {
        const { clearSearchResult, setSearchValue } = this.props;
        this.setState({ searchValue: this.cleanValue(event.target.value) });
        setSearchValue(this.cleanValue(event.target.value));
        if (!event.target.value) {
            clearSearchResult({});
            this.setState({ showRecents: true });
        } else this.setState({ showRecents: false });
    };

    onFocus = () => {
        const { brand } = this.props;
        const { searchPlaceholderValue, currentPrompt } = this.state;

        this.setState({ showRecents: true });
        if (searchPlaceholderValue === currentPrompt) {
            if (this.searchBrands.includes(brand.code)) {
                this.setState({ searchPlaceholderValue: PROMPTRAISED });
            } else {
                this.setState({ searchPlaceholderValue: PROMPTHOME });
            }
        }
        if (searchPlaceholderValue !== '' && searchPlaceholderValue !== currentPrompt) {
            this.setState({ showClearIcon: true });
        }
    };

    onBlur = () => {
        const { currentPrompt } = this.state;

        this.setState((prevState) => {
            if (prevState.searchPlaceholderValue.trim() === '') {
                return { searchPlaceholderValue: currentPrompt };
            }
            return {};
        });
    };

    onKeyPress = (event) => {
        if (
            (event.which && event.which === ENTER_KEY)
            || (event.keyCode && event.keyCode === ENTER_KEY)
        ) {
            this.submitSearchForm(event);
        }
    };

    onKeyUp = () => {
        const { searchValue } = this.state;

        if (searchValue?.trim() !== '') {
            this.setState({ showClearIcon: true });
        } else {
            this.setState({ showClearIcon: false });
        }
    };

    cleanValue = (v, maxLength = 100) => {
        // filter out control characters to help prevent XSS ...
        const cleanVal = v.replace(/[\x00-\x1F\x7F-\x9F]/g, ''); /* eslint no-control-regex: "off" */
        // ... and don't allow value to exceed maxLength
        return cleanVal.length <= maxLength ? cleanVal : cleanVal.substr(0, maxLength);
    };

    cleanTerm = (input) => {
        // removes extra spaces an ., example input +_)(*()()_    roses . +_)()_)))() red +_)()_))

        const a = input.replace(/[`~+!@#$%^&*()_|=?;:'",.<>{}/\\]/g, ''); // replaces all special chars with spaces
        const b = a.replace(/\s+/g, ' '); // removes extra consecutive spaces with just one space
        const c = b.replace(/(^\s+|\s+$)/g, ''); // removes spaces in the beginning and end of search term
        // output would be "roses+red" for the url
        return c;
    }

    concatSearchTerm = (url, value) => {
        let searchTerm = '';
        if (url.indexOf('?') >= 0) {
            searchTerm = `&searchTerm=${this.cleanTerm(value)?.trim().replace(/ /g, '_').toLowerCase()}`; // replaces spaces between words with _
        } else if (url.indexOf('searchTerm=') >= 0) {
            searchTerm = '';
        } else {
            searchTerm = `?searchTerm=${this.cleanTerm(value)?.trim().replace(/ /g, '_').toLowerCase()}`; // replaces spaces between words with _
        }
        return `${url}${searchTerm}`;
    }

    addSearchQueries = () => {
        const { getSearchResult } = this.props;
        if (this.state.searchValue !== '') { // just update browser query param
            getSearchResult(this.state.searchValue);
            if (localStorage.getItem('searchQueries')) {
                const items = JSON.parse(localStorage.getItem('searchQueries'));
                if (!items.includes(this.state.searchValue)) {
                    items.push(this.state.searchValue);
                    localStorage.setItem('searchQueries', JSON.stringify(items));
                }
            } else {
                const items = [this.state.searchValue];
                localStorage.setItem('searchQueries', JSON.stringify(items));
            }
            this.setState({ showRecents: false });
        }
    }

    submitSearchForm = (evt) => {
        const {
            pageLoaded, brand, trackEvent,
        } = this.props;
        const { currentPrompt, searchValue } = this.state;
        if (typeof document !== 'undefined') {
            let searchInput = null;
            evt.preventDefault();
            const { history, typeSearchBox } = this.props;
            const searchBox = document.getElementById(`SearchBox_${typeSearchBox}`);
            if (
                searchBox
                && (searchBox.value !== PROMPT
                    || searchBox.value !== PROMPTHOME
                    || searchBox.value !== PROMPTRAISED)
            ) {
                searchInput = searchBox.value !== '' ? searchBox.value : null;
            }

            const addSearchTerm = brand['search-append-searchterm-url-param'] || false;
            if (this.esAutoCompleteEnabled) {
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Test Impression',
                    eventAction: 'Site Search Test - Elastic',
                    eventLabel: '<<pageType>>',
                    searchVariety: 'Manual',
                    searchPhrase: searchValue,
                });
            }

            if (this.esAutoCompleteEnabled) {
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Test Impression',
                    eventAction: 'Site Search Test - Auto Complete',
                    eventLabel: '<<pageType>>',
                    searchVariety: 'Manual',
                    searchPhrase: searchValue,
                });
            }

            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Search',
                eventAction: searchValue,
                eventLabel: 'MANUAL | <<pageType>>',
                searchVariety: 'Manual',
                searchPhrase: searchValue,
            });

            if (searchInput && searchInput.trim() && searchInput !== currentPrompt) {
                const cleanSearchInput = this.cleanTerm(searchInput);
                let searchTermValue = cleanSearchInput
                    .trim()
                    .replace(/ /g, '+') // replaces spaces between words with +
                    .toLowerCase();
                if (searchTermValue.length !== 0 && addSearchTerm) {
                    searchTermValue = this.concatSearchTerm(searchTermValue, cleanSearchInput);
                }
                this.setState({ loading: true }, () => {
                    history.push({
                        pathname: `/searchterm/${searchTermValue.length === 0 ? 'notfound' : searchTermValue}`,
                        state: { searchInputTerm: searchValue || '' },
                    });
                });
                searchBox.blur();
                this.addSearchQueries();
                this.clearSearch(false);
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });
            }
            if (!searchInput) {
                this.setState({ searchPlaceholderValue: MODALMESSAGE });
            }
        }
        if (pageLoaded !== '' && this.searchBrands.includes(brand.code)) {
            this.setState({ loading: false });
        }
    };

    clearSearch = (persistValue = false, queryString = null) => {
        const { trackEvent } = this.props;
        const { searchValue } = this.state;
        const clear = {
            showClearIcon: false,
            showInputValue: false,
        };
        if (!persistValue) {
            clear.searchPlaceholderValue = PROMPTRAISED;
            clear.searchValue = '';
        } else {
            clear.showInputValue = true;
            if (queryString) {
                clear.searchValue = '';
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Search',
                    eventLabel: queryString,
                    eventAction: 'SUGGESTED | <<pageType>>',
                    searchVariety: 'Suggested',
                    searchPhrase: searchValue,
                });
            }
        }
        this.setState(clear);
    };

    handleClickOutsideSearch(event) {
        const { showClearIcon } = this.state;
        if (this.searchContainerRef && event?.target && this.searchContainerRef?.current && !this.searchContainerRef.current.contains(event.target) && showClearIcon) {
            this.setState({
                showClearIcon: false,
            });
        }
    }

    renderButtonSearch = (classSearchButton) => (
        <Button className={classSearchButton} id="btn-search" data-test="hp-header-search-button" name="hpSearchButton" onClick={this.submitSearchForm} type="button" />
    );

    closeRecents = () => {
        if (!(document.activeElement === this.searchRef.current)) {
            this.setState({ showRecents: false });
        }
    }

    clearRecents =() => {
        this.setState({ showRecents: false });
        localStorage.removeItem('searchQueries');
    }

    handleRecentsItemClick=(data) => {
        this.setState({ searchValue: data, showRecents: false }, () => {
            this.onKeyUp();
        });
    }

    renderRecents = () => {
        const { classes } = this.props;
        const items = JSON.parse(localStorage.getItem('searchQueries'));
        if (items) {
            return (
                <ClickAwayListener onClickAway={this.closeRecents}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.recentsHeader} colSpan={4}>RECENT SEARCHES</TableCell>
                                    <TableCell align="right"><CloseIcon className={classes.clearRecents} onClick={this.clearRecents} /></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((data) => (
                                    <TableRow
                                        onClick={() => this.handleRecentsItemClick(data)}
                                        className={classes.recentsItem}
                                        key={data}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row" colSpan={5}>
                                            {data && data.toUpperCase()}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </ClickAwayListener>
            );
        }
        return null;
    }

    render() {
        const {
            classes, typeSearchBox, brand, suggestData, trackEvent, setSearchResult,
        } = this.props;
        const {
            searchValue,
            currentPrompt,
            loading,
            searchPlaceholderValue,
            showClearIcon,
            ieBrowser,
            showInputValue,
        } = this.state;
        // Adding the class according of the typeSearchBox.
        // typeSearchBox 'menu', 'homepage', 'header' (header is for HD) or empty
        let classSearchBoxLabel = classes.searchBoxLabel;
        let classSearchInput = [classes.searchInput];
        let classSearchButton = [classes.searchButton];
        let iconSearch = null;
        let classWrapper = null;

        switch (typeSearchBox) {
            case 'menu':
                classSearchInput.push(classes.searchInputMenu);
                classSearchButton.push(classes.searchButtonMenu);
                break;
            case 'desktop':
                classSearchInput.push(classes.searchInputDesktopHome);
                classSearchButton.push(ieBrowser ? classes.searchButtonDesktopHomeIe : classes.searchButtonDesktopHome);
                classSearchBoxLabel = classes.classSearchBoxDesktopLabel;
                classWrapper = classes.wrappDesktopHomePage;
                break;
            case 'homepage':
                classSearchInput.push(classes.searchInputHome);
                classSearchButton.push(classes.searchButtonHome);
                iconSearch = <SearchIcon className={classes.searchIcon} style={{ maxWidth: '40px' }} />;
                classWrapper = classes.wrappHomePage;
                break;
            case 'header':
                classSearchBoxLabel = classes.classSearchBoxLabelHeaderRaised;
                classSearchInput.push(classes.searchInputHeaderRaised);
                classSearchButton.push(classes.searchButtonHeaderRaised);
                classWrapper = classes.wrappHeaderRaised;
                break;
            case 'category':
                break;
            default:
                classSearchInput = [classes.searchInput];
                classSearchButton = [classes.searchButton];
                break;
        }

        // Add the class hasValue.
        if (
            searchValue !== undefined
            && searchValue !== null
            && searchValue !== ''
            && searchValue !== currentPrompt
        ) {
            classSearchInput.push(classes.hasValue);
        }

        classSearchInput = classSearchInput.join(' ');
        classSearchButton = classSearchButton.join(' ');
        const searchPlaceholderCss = searchPlaceholderValue === MODALMESSAGE ? classes.searchPlaceholderError : '';
        if (typeof window !== 'undefined') {
            // Avoid displaying if page is checkout
            if (window.location.href.split('/').indexOf('checkout') >= 0) {
                return null;
            }
            if (window.location.href.split('/').indexOf('checkout') >= 0 && window.location.href.split('/').indexOf('order-confirmation') < 0) {
                return null;
            }
        }

        return (
            <>
                <div ref={this.searchContainerRef} className={classWrapper}>
                    <form
                        id="CatalogSearchForm"
                        name="CatalogSearchForm"
                        method="get"
                        onSubmit={this.submitSearchForm}
                        className={ieBrowser ? classes.seachFormIe : classes.searchForm}
                    >
                        <label
                            className={`${classSearchBoxLabel} ${classes.searchFormLabel}`}
                            htmlFor={`SearchBox_${typeSearchBox}`}
                        >
                            {iconSearch}
                            <input
                                id={`SearchBox_${typeSearchBox}`}
                                name={`searchTerm_${typeSearchBox}`}
                                className={`${classSearchInput} ${searchPlaceholderCss} ${classes.searchInputBox}`}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                onChange={this.onChange}
                                onKeyPress={this.onKeyPress}
                                onKeyUp={this.onKeyUp}
                                autoComplete="off"
                                value={searchValue}
                                type="text"
                                readOnly={loading}
                                placeholder={this.state.deviceType === 'desktop' ? searchPlaceholderValue : 'Search'}
                                ref={this.searchRef}
                                data-test="header-search-box" // do NOT change or remove data-test attribute
                                data-testid="header-search-box"
                            />
                            <span className={classes.ariaInvisible}>Search Box</span>
                            <CloseIcon
                                onClick={() => this.clearSearch()}
                                className={`close-icon ${brand.code} ${classes.resetSearchIcon} ${classes.closeIcon} ${(showClearIcon || showInputValue) ? classes.resetSearchIconShow : classes.resetSearchIconHide
                                    } ${classes.clearSearchIconBtn}`}
                            />
                        </label>
                    </form>
                    {/* BLOOMREACH SEARCH */}
                    {Object.entries(suggestData).length > 0
                        && !this.esAutoCompleteEnabled
                        && showClearIcon
                        && brand?.code !== 'PLA'
                        && (
                            <SearchResultDropDown
                                suggest={suggestData}
                                clearFunc={this.clearSearch}
                                showClearIcon={showClearIcon}
                                track={trackEvent}
                                phrase={searchValue}
                                concatSearchTerm={this.concatSearchTerm}
                                setSearchResult={setSearchResult}
                            />
                        )}

                    {/* ELASTIC SEARCH */}
                    {this.esAutoCompleteEnabled && showClearIcon && searchValue && <ElasticSearchSuggestions cleanTerm={this.cleanTerm} concatSearchTerm={this.concatSearchTerm} track={trackEvent} brand={brand.domain} clearSearch={this.clearSearch} phrase={searchValue} setSearchResult={setSearchResult} />}

                    {!loading && this.renderButtonSearch(classSearchButton)}
                    {loading && (
                        <div className="loading-btn" id="searchBtnLoading">
                            <CircularProgress className={classes.progress} size={30} thickness={6} />
                        </div>
                    )}
                </div>
                <p className={classes.searchLabel}><sup class={classes.textDanger}>*</sup>Type keyword and press enter.</p>
                <div>
                    {this.state.showRecents && this.renderRecents()}
                </div>
            </>
        );
    }
}

Search.propTypes = {
    typeSearchBox: PropTypes.string,
    searchInputTerm: PropTypes.string,
    brand: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    pageLoaded: PropTypes.string,
    history: PropTypes.object.isRequired,
    getSearchResult: PropTypes.func.isRequired,
    suggestData: PropTypes.object,
    clearSearchResult: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    focusOnShow: PropTypes.bool,
    setSearchValue: PropTypes.func.isRequired,
    setSearchResult: PropTypes.func.isRequired,
    ssrDeviceType: PropTypes.string.isRequired,
};

Search.defaultProps = {
    typeSearchBox: null,
    searchInputTerm: '',
    pageLoaded: '',
    suggestData: {},
    focusOnShow: false,
};

const mapStateToProps = (state) => {
    const { ui } = state;
    return {
        pageLoaded: ui.pageFullyLoaded,
        suggestData: selectors.getSuggestionData(state),
        ssrDeviceType: getSSRDeviceType(state),
    };
};

const mapDispatchToProps = {
    getSearchResult: operations.getSearchResult,
    clearSearchResult: operations.clearSearchResult,
    trackEvent: tagManagerActions.trackEvent,
};

export default withRouter(
    withStyles(styles, { withTheme: true })(
        connect(
            mapStateToProps,
            mapDispatchToProps,
        )(Search),
    ),
);
